import React from "react";
import Modal from "../../common/Modal/Modal";

/*
    Modal opens when user created a new Requests in Data Requests,
    but did not send it and wants to navigate to another page.
*/

export default function WarningModal({ isOpen, onClose, onNavigate }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={"Warning"}
      showCustomContent={true}
      customContent={
        <>
          {/* Error message originated from the submit completed modal */}
          <div className="noproperties-body">
          You have unsent requests. Are you sure you want to navigate away from this page?
          </div>
          <div>
            <div className="button-close-container">
            <button className="plain-close-button" onClick={onNavigate}>
                Yes
              </button>
              <button className="button-close" onClick={onClose}>
                No
              </button>
            </div>
          </div>
        </>
      }
    />
  );
}
